import type { RootState } from '@/store/rootReducer'
import { resolveAIModelsAccessDecision } from '@/services/ai/aiAccessPolicy'

/**
 * Always compute AI Studio access from live user entitlement/credits state.
 * Do not rely on aiFashion slice snapshots, which can be stale post-checkout.
 */
export const selectAIStudioLiveAccessDecision = (state: RootState) => resolveAIModelsAccessDecision(state)

/**
 * Primitive selector for React useSelector subscriptions.
 * Keeps AI Studio button-set rerenders tied to actual gate flips only.
 */
export const selectAIStudioAccessAllowed = (state: RootState): boolean => (
  resolveAIModelsAccessDecision(state).allowed
)
